var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FAQPage',_vm._b({},'FAQPage',_vm.faqPageProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }